import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { ApiError } from "./api/client.js";
import { AuthProvider } from "./auth/AuthProvider.jsx";
import "./auth/amplify.js";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retrying a refusal just repeats it - a 403 will not become a 200 on
      // the third attempt, and the delay makes the app feel broken rather
      // than merely restricted.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.isRefusal || error.isConflict)) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
});

const root = document.getElementById("root");
if (root === null) throw new Error("No #root element in the document.");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
